export const GreenColor = "#1EF875"
export const TextColor = "#F4F4F4"
export const SubtextColor = "#D1D3DB"